import React from "react";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IWikifolioAlphaKeyFigureGroupSection } from "src/api/server/wf-detail.types";
import { BestAlpha } from "src/components/pages/detail/key-figures/components/alpha/best-alpha";
import { OtherAlphas } from "src/components/pages/detail/key-figures/components/alpha/other-alphas";
import { SecondBestAlpha } from "src/components/pages/detail/key-figures/components/alpha/second-best-alpha";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { WfPopover } from "src/components-mui/base/wf-popover/wf-popover";

interface IAlphaProps {
    alphaSection: IWikifolioAlphaKeyFigureGroupSection;
}

export const Alpha = ({ alphaSection }: IAlphaProps) => {
    const { t } = useTranslation("wf-detail");

    return (
        <Box component="section">
            <Box
                sx={{
                    display: "flex",
                    pt: 5,
                    alignItems: "center",
                }}
            >
                <WfHeading component="h3" fontSize="md" sx={{ mb: 2 }}>
                    {t("headlines.alpha")}
                </WfHeading>
                {alphaSection.tooltip && (
                    <WfPopover
                        PopoverTrigger={<PopoverButtonIconInfo ariaLabel={t("headlines.alpha")} sx={{ ml: 1, mb: 2 }} />}
                        {...alphaSection.tooltip}
                    ></WfPopover>
                )}
            </Box>
            <Stack spacing={2}>
                {alphaSection.bestAlpha && (
                    <BestAlpha
                        alpha={alphaSection.bestAlpha}
                        creationDate={alphaSection.creationDate}
                        shortDescription={alphaSection.shortDescription}
                    />
                )}
                {alphaSection.secondBestAlpha && <SecondBestAlpha alpha={alphaSection.secondBestAlpha} creationDate={alphaSection.creationDate} />}
                {alphaSection.otherAlphas && alphaSection.otherAlphas.length > 0 && (
                    <OtherAlphas alphas={alphaSection.otherAlphas} creationDate={alphaSection.creationDate} />
                )}
            </Stack>
        </Box>
    );
};
